import { render, staticRenderFns } from "./ItemTurno.vue?vue&type=template&id=6892dbf2&"
import script from "./ItemTurno.vue?vue&type=script&lang=js&"
export * from "./ItemTurno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports